export default __webpack_public_path__ + "static/media/cartao_black.0b6392ad.png";